import { render, staticRenderFns } from "./Registro_mobile.vue?vue&type=template&id=b92e2668&"
import script from "./Registro_mobile.vue?vue&type=script&lang=js&"
export * from "./Registro_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Registro_mobile.vue?vue&type=style&index=0&id=b92e2668&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports